
























import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { NamedOnboarding as OnboardingRouteName } from "@/employee/route-names";

@Component({
  components: {
    Button
  }
})
export default class ReviewTerms extends Vue {

  goToStep (stepKey: string) {
    this.$router.push({ name: OnboardingRouteName, params: { stepKey } });
  }

}
